import React, { useRef, useEffect, useCallback } from 'react';
import { FormHandles } from '@unform/core';
import { Form as UForm } from '@unform/web';
import Grid from '@material-ui/core/Grid';
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import getValidationError from '../../../utils/getValidationsErros';
import {
    WrapperLabel,
    Input,
    InputHidden,
    ButtonIcon,
    Button,
} from '../../../components/Forms';
import {
    Container,
    GridButtons,
    WrapperBtnInfo,
    WrapperBtnCancel,
    WrapperBtnSubmit,
} from './styles';
import { InfoIcon } from '../../../styles/icons';
import { useToast } from '../../../hooks/toast';
import { useHttp } from '../../../hooks/http';
import { IMake } from 'interfaces';

interface IForm {
    make: IMake;
}

const Profile: React.FC<IForm> = ({ make }) => {
    const formRef = useRef<FormHandles>(null);
    const history = useHistory();
    const { addToast } = useToast();
    const {
        httpPost, httpPut, loading, unLoading,
    } = useHttp();

    useEffect(() => {
        unLoading();
        if (make) {
            formRef.current?.setData({
                ...make,
            });
        }
    }, [make]); // eslint-disable-line

    const handleSubmit = useCallback(async (payload: any) => {

        const _make = {
            ...payload
        };

        formRef.current?.setErrors({});

        try {
            const schema = Yup.object().shape({
                name: Yup.string().required('Nome é obrigatório'),
            });

            await schema.validate(_make, { abortEarly: false });

            if (make.id) {
                const { status } = await httpPut(`marcas/${_make.id}`, _make);
                if (status === 200) {
                    addToast({ title: 'Alterado com sucesso!', type: 'warning' });
                    history.push('/makes');
                }
            } else {
                const { status } = await httpPost('marcas', _make);
                if (status === 200) {
                    addToast({ title: 'Salvo com sucesso!', type: 'success' });
                    history.push('/makes');
                }
            }
        } catch (err) {
            if (err instanceof Yup.ValidationError) {
                const erros = getValidationError(err);
                formRef.current?.setErrors(erros);
            }
        }
    }, [make, httpPost, httpPut, history, addToast]);

    return (
        <Container>
            <UForm ref={formRef} onSubmit={handleSubmit}>
                <InputHidden name="id" />
                <Grid container spacing={1}>
                    <WrapperLabel label="Nome" xs={12} >
                        <Input
                            name="name"
                            maxLength={30}
                            style={{ textTransform: 'uppercase' }}
                        />
                    </WrapperLabel>
                </Grid>
                <GridButtons>
                    <WrapperBtnInfo>
                        <ButtonIcon
                            title="Instruções"
                        >
                            <InfoIcon />
                        </ButtonIcon>
                    </WrapperBtnInfo>
                    <WrapperBtnCancel>
                        <Button
                            type="button"
                            onClick={() => { history.push('/dashboard'); }}
                        >
                            Cancelar
                        </Button>
                    </WrapperBtnCancel>
                    <WrapperBtnSubmit>
                        <Button
                            type="submit"
                            isLoading={loading}
                        >
                            Salvar
                        </Button>
                    </WrapperBtnSubmit>
                </GridButtons>
            </UForm>
        </Container>
    );
}

export default Profile;